const ASSETS = {
	ROOT: '/assets',
} as const

export { ASSETS }
